
import { defineComponent, ref, computed } from 'vue'
import AppHeader from '@/components/Header.vue'
import { GetBackUpDevices } from '@/apis/networkpoint'
import getRoute from '@/compositions/route'
import { Toast, Empty } from 'vant'

export default defineComponent({
  name: 'Networkpoint-Devices',
  components: {
    AppHeader,
    VanEmpty: Empty,
  },
  setup() {
    const { params } = getRoute()
    const guid = computed(() => {
      return params.value?.guid || ''
    })
    const items = ref([])
    const isLoading = ref(false)
    const getItems = async (): Promise<void> => {
      isLoading.value = true
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      try {
        const result: any = await GetBackUpDevices(guid.value as string)
        items.value = result.sort((a: any, b: any) => b.count - a.count)
        Toast.clear()
        isLoading.value = false
      } catch (err: any) {
        Toast.clear()
        isLoading.value = false
        const message: string = err.message
        Toast(message)
        console.error(message)
      }
    }
    getItems()
    return {
      items,
      isLoading,
    }
  },
})
